import React, { createRef } from 'react';
import PropTypes from 'prop-types';

export class ManagedTextInput extends React.Component {
  static propTypes = {
    autoHeight: PropTypes.bool,
    autoHeightMax: PropTypes.number,
    forwardedRef: PropTypes.object,
    name: PropTypes.string,
    type: PropTypes.oneOf(['text', 'textarea', 'number']),
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onEnter: PropTypes.func,
    onValueChange: PropTypes.func.isRequired
  }

  componentDidMount() {
    this.calculateHeight();
  }

  componentDidUpdate(previousProps) {
    if (this.props.value !== previousProps.value) {
      this.calculateHeight();
    }
  }

  get ref() {
    if (this.props.forwardedRef) {
      return this.props.forwardedRef;
    } else {
      this.innerRef ||= createRef();
      return this.innerRef;
    }
  }

  calculateHeight() {
    if (this.props.autoHeight && this.props.type === 'textarea' && this.ref?.current) {
      this.initialHeight ||= this.ref.current.clientHeight;

      // Temporarily reset height to auto so scrollHeight is the content height
      this.ref.current.style.height = 'auto';
      const contentHeight = this.ref.current.scrollHeight;

      let height = Math.max(contentHeight, this.initialHeight);
      if (this.props.autoHeightMax) {
        height = Math.min(height, this.props.autoHeightMax);
      }

      // A little extra is necessary to prevent a scrollbar
      this.ref.current.style.height = `${height + 4}px`;
    }
  }

  handleChange = (event) => {
    this.props.onChange({ [this.props.name]: event.target.value }, event);
    this.props.onValueChange(event.target.value, event);
  }

  handleKeyUp = (event) => {
    if (event.key == 'Enter') this.props.onEnter();
  }

  render() {
    const { type, value, onChange, onValueChange, onEnter, forwardedRef, ...props } = this.props;

    const inputProps = {
      ...props,
      ref: this.ref,
      value: value || '',
      onChange: this.handleChange
    };

    if (onEnter) inputProps.onKeyUp = this.handleKeyUp;

    return type === 'textarea'
      ? <textarea {...inputProps} />
      : <input {...inputProps} />;
  }
}

export default React.forwardRef((props, ref) => {
  return <ManagedTextInput {...props} forwardedRef={ref} />;
});
